import { z } from 'zod';

/**
 * Wire schemas for comment API responses (snake_case from gateway)
 */

export const commentWireSchema = z.object({
  id: z.string(),
  check_in_id: z.string(),
  user_id: z.string(),
  content: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
  user: z.object({
    id: z.string(),
    username: z.string().optional(),
    display_name: z.string().optional(),
    avatar_url: z.string().nullable().optional(),
    is_sentinel: z.boolean().optional(),
  }),
});

export type CommentWire = z.infer<typeof commentWireSchema>;

export const paginatedCommentsResponseWireSchema = z.object({
  items: z.array(commentWireSchema),
  total: z.number().int().min(0),
  page: z.number().int().min(1),
  per_page: z.number().int().min(1).max(100),
  total_pages: z.number().int().min(0),
});

export type PaginatedCommentsResponseWire = z.infer<typeof paginatedCommentsResponseWireSchema>;
